module.exports = __webpack_public_path__ + "static/media/tabana-01.bb24e623.png";